import React from "react";

import "./Credits.scss";

export const Credits: React.FC = () => (
  <div className="infoModalContent infoModalContent--credits">
    <h2>Credits</h2>
    <ul>
      <li>Yuri Suzuki</li>
      <li>Counterpoint</li>
      <li>Marisol Ambriz</li>
      <li>Gabriel Vergara II</li>
      <li>Maxwell Sterling</li>
      <li>Gaku Terauchi</li>
      <li>A Guy Called Gerald</li>
      <li>Alberto Balazs</li>
    </ul>
  </div>
);
